import { PowerSupply, DefaultService} from "@psnb/psnb-api";
import {Injectable} from "@angular/core";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class InvalidPowerSupplyService {
    constructor(private powerSupplyService: DefaultService) {
        this.getAllInvalidPowerSupplies();
    }

    getAllInvalidPowerSupplies() {
        return this.powerSupplyService.getInvalidPowerSupplies()
            .pipe(map(result => result));
    }

    deleteAllInvalidPowerSupplies() {
        return this.powerSupplyService.deleteAllInvalidPowerSupplies()
            .pipe(map(result => result));
    }

    deleteInvalidPowerSupply(id: number, model: PowerSupply) {
        return this.powerSupplyService.deleteInvalidPowerSupply(id, model)
            .pipe(map(result => result));
    }
}
